import { useForm } from 'react-hook-form'
import AdminAppBar from './SuperUserAppBar'
import { /* useEffect, */ useState } from 'react'
import { IService } from '../../../types/services'
import { makeStyles } from '@material-ui/core/styles'
import { getServicesUser } from '../../../services/services'
import { JustiInputText } from '../../../components/InputText'
import Alert , { ActionsOptType } from '../../../components/Alert'
import { Button, Container, Typography, Grid } from '@material-ui/core'
import SearchItem from '../../../modules/DocEngine/SuperUserPanel/SearchItem'
/* import DocumentItem from '../../Documents/DocumentItem' */

/**
 * define styles for the component
*/
const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flexContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: "center",
    width: '70%'
  },
}))

/**
 * Custom `Search` component declaration.
 * this component is used to search list services from any user
 * @return Search
*/
const Search = () => {
  const classes = useStyles()
  const { control, errors } = useForm()
  const [services, setServices] = useState<IService[] | null>()
  const [alertOptions, setAlertOptions] = useState<ActionsOptType>({
    message: null,
    type: null,
    open: false,
  })

  /**
   * Custom `Search` component declaration.
   * this method is used to search services by name user or email
   * @return {Void}
  */
  const handleSubmit = async (event:any) => {
    event.preventDefault()
    const val = event.target.dataUser.value
    if(getServicesUser)
    {
      const { data, error } = await getServicesUser(val)
      if(data) setServices(data)
      if(!data) setAlertOptions({ message: "Este usuario no tiene documentos realizados hasta el momento.", open: true, type: 'error' })
      if (error) setAlertOptions({ message: error, open: true, type: 'error' })
    }
  }

  return (
    <>
      <AdminAppBar />
      <Container className={classes.container} maxWidth="md">
        <Alert alertOptions={alertOptions} setAlertOptions={setAlertOptions} />
        <Typography
          component="p"
          variant="body1"
          align="center"
          color="textPrimary"
          gutterBottom
          style={{ fontSize: '2rem', fontWeight: 'bold' }}
        >
          ¡Te damos la bienvenida a Justiexpress!
        </Typography>
        <Typography
          variant="subtitle2"
          align="justify"
          color="textSecondary"
          paragraph
          style={{ whiteSpace: 'pre-line' }}
        >
          En este espacio podrás encontrar y editar los documentos realizados por nuestros usuarios
        </Typography>
        <form
            className={classes.flexContainer}
            noValidate
            onSubmit={handleSubmit}
          >
          <JustiInputText
            name={'dataUser'}
            copy={'Nombre Usuario / Correo electrónico'}
            errorMessage={'Usuario inválido'}
            errors={errors}
            control={control}
            autoFocus={true}
          /> 
          <Button
            /*/* onClick={handleSubmit} ///*/
            style={{ marginLeft: '2.5vh', marginTop: '0.9vh' }}
            type="submit"
            disabled={Object.keys(errors).length > 0}
            variant="contained"
            size= 'large'
            >
              Buscar
          </Button>
        </form>
        <Grid style={{ marginTop: '4.0vh'}} container justifyContent="center" spacing={4}>
        {services ? (
            services.map((service: IService, index: number) => (
              <Grid item key={index} xs={12} sm={6} md={4}>
                <SearchItem service={service} />
              </Grid>
            ))
          ) : (
            <></>
        )}
        </Grid> 
      </Container>
    </>
  )
}

export default Search